export default import.meta.ROLLDOWN_FILE_URL_hO4dd8ILk$iZF7aFIOUkdg